import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tgd-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit {
  ngOnInit(): void {}
}
